import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectProfile, selectLoaded, selectLoading } from '../selectors/profile.selector';
import { profileActions } from '../actions/profile.actions';

@Service()
export class ProfileFacade {
    private readonly store = inject(Store);

    // Signal-based (preferred for new components)
    readonly profile = this.store.selectSignal(selectProfile);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);

    // Observable-based (for compatibility with existing code)
    readonly profile$ = this.store.select(selectProfile);
    readonly loaded$ = this.store.select(selectLoaded);
    readonly loading$ = this.store.select(selectLoading);

    // Dispatch
    getProfile(): void {
        this.store.dispatch(profileActions.getProfile());
    }

    updateLanguage(language: string): void {
        this.store.dispatch(profileActions.updateLanguage({ language }));
    }

    clear(): void {
        this.store.dispatch(profileActions.clear());
    }
}
